'use client';

import { Pricing } from '@/components/marketing/Pricing';
import { MarketingCTA } from '@/components/marketing/MarketingCTA';

export default function PricingPage() {
  return (
    <div className="min-h-screen">
      <Pricing />
      <MarketingCTA />
    </div>
  );
}
